import { Component, OnInit } from '@angular/core';
import { ReachUs } from 'src/models/reachus.model';
import { ReachusService } from 'src/services/reachus.service';

@Component({
  selector: 'app-reach-us',
  templateUrl: './reach-us.component.html',
  styleUrls: ['./reach-us.component.css']
})
export class ReachUsComponent implements OnInit {

  reachus: ReachUs;
  reachusResponse: string = '';
  constructor(private reachUsService:ReachusService) {
    this.reachus = new ReachUs();
  }

  ngOnInit() {
    this.GetMbileNos();
    this.GetEmailList();
  }

MobileList:any[]=[];
GetMbileNos()
{
  debugger;
  let nos =  (<HTMLInputElement>document.getElementById("hdnMobile")).value;
  this.MobileList = nos.split(",");
}

EmailList:any[]=[];
GetEmailList()
{
  debugger;
  let emails =  (<HTMLInputElement>document.getElementById("hdnEmail")).value;
  this.EmailList = emails.split(",");
}


  onSubmit(reachusdata) {
    this.reachusResponse = '';

    if (!this.reachus.Name) {
      this.reachusResponse = "Please enter the name";
      return;
    }
    if (!this.reachus.Email) {
      this.reachusResponse = "Please enter the email";
      return;
    }
    if (!this.reachus.PhoneNo) {
      this.reachusResponse = "Please enter the phone number";
      return;
    }
    if (this.reachus.PhoneNo.length != 10) {
      this.reachusResponse = "Please enter valid phone number";
      return;
    }

    if (!this.reachus.Message) {
      this.reachusResponse = "Please enter the message";
      return;
    }

    if (!this.reachus.Captcha) {
      this.reachusResponse = "Please verify you are human";
      return;
    }
    if(!this.validateEmail()){
      this.reachusResponse = "Email address is invalid";
      return;
    }
    console.log(this.reachus);
    this.reachUsService.Save(this.reachus).subscribe(
      data => {

        var result = data;
        console.log(data);
        grecaptcha.reset(2);
    this.reachusResponse = "Your request has been submitted. Our executive will call you soon.";
    this.reachus = new ReachUs();
        
      },
      error => {        
        console.log(error);
      }
    );


    
  }
  validateEmail(){  
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(this.reachus.Email).toLowerCase());    
   }

  onCaptchaClick(captchaResponse: string) {
    this.reachus.Captcha = captchaResponse;
    console.log(`Resolved response token: ${captchaResponse}`);
  }

}
